import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const formsApi = createApi({
  reducerPath: "formsApi",
  baseQuery: customFetchBase({ url: "forms/" }),
  endpoints: (builder) => ({
    createForm: builder.mutation({
      query: (data) => ({
        method: "POST",
        body: data,
        url: "contact",
      }),
    }),

    // brief
    getBrief: builder.query({
      query: (code) => ({
        url: "brief/form?code=" + code,
        method: "GET",
      }),
    }),
    sendBrief: builder.mutation({
      query: (data) => ({
        body: data,
        method: "PUT",
        url: "brief/form",
      }),
    }),

    // employment
    sendApply: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "apply",
      }),
    }),
    verifyApply: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "apply/submit",
      }),
    }),
  }),
});
export const {
  useCreateFormMutation,
  useGetBriefQuery,
  useSendBriefMutation,
  useSendApplyMutation,
  useVerifyApplyMutation
} = formsApi;
